import { Offcanvas } from "bootstrap";

const offcanvas = document.querySelector(".offcanvas");

new Offcanvas(offcanvas);
